import { type SearchEntry } from '@ctn/ui/types/ctn-filter-bar';
import { yupResolver } from '@hookform/resolvers/yup';
import { type Resolver } from 'react-hook-form';
import * as yup from 'yup';

import { PAGE_SIZE } from '@/constants/table.constants';
import { SOLICITUD_ESTADOS } from '@/constants/tramite.constants';

export const PAYLOAD_PAGINATION = {
	start: 0,
	limit: PAGE_SIZE.OPERACIONES,
};

export const PAYLOAD_DEFAULT = (idTipoTramite: number) => ({
	...PAYLOAD_PAGINATION,
	listaIdsEstadoSolicitud: [SOLICITUD_ESTADOS.BORRADOR],
	listaIdsTipoTramite: [idTipoTramite],
});

export type FilterFormData = {
	tipoBusqueda: string;
	busqueda: string;
	listaIdsTipos: string[];
	listaIdsEstados: string[];
	listaIdsEstadosSubsanacionFirma: string[];
	search?: SearchEntry[];
};
    
export const getSchema = (): Resolver<FilterFormData> => {
	const schema = yup.object().shape({
		tipoBusqueda: yup.string(),
		busqueda: yup.string(),
		listaIdsTipos: yup.array(),
		listaIdsEstados: yup.array(),
		listaIdsEstadosSubsanacionFirma: yup.array(),
	});
	return yupResolver(schema) as Resolver<FilterFormData>;
};
    
export const defaultValues = (idTipoTramite: number) => ({
	tipoBusqueda: 'numeroTramite',
	busqueda: '',
	listaIdsTipos: [String(idTipoTramite)],
	listaIdsEstados: [],
	listaIdsEstadosSubsanacionFirma: [],
	search: [],
});